import React from "react";

import { Spacer } from "shared/layout";
import {
  EditInfoBlockItemsHookProps,
  getInfoBlockItemTeaser,
  useEditInfoBlock,
  useEditInfoBlockItems,
} from "shared/utils";
import { InfoBlockItems, InfoBlockAddButtons } from "shared/components";
import {
  CreateInfoBlockItemModal,
  EditInfoBlockItemModal,
  ChooseInfoBlockItemModal,
  DeleteInfoBlockItemModal,
} from "Bands/containers";

interface EditInfoBlockItemsProps extends EditInfoBlockItemsHookProps {
  infoBlockHasError?: boolean;
}

export const EditInfoBlockItems: React.FC<EditInfoBlockItemsProps> = ({
  infoBlockApiStatus,
  infoBlockHasError,
  ...rest
}) => {
  const { patchInfoBlock, unlinkFromInfoBlock } = useEditInfoBlock({
    ...rest,
  });

  const {
    selectedItem,
    openAddModal,
    setOpenAddModal,
    openChooseModal,
    setOpenChooseModal,
    openEditModal,
    setOpenEditModal,
    openDeleteModal,
    setOpenDeleteModal,
    getItemActions,
    getDisabledItems,
    itemsProps,
  } = useEditInfoBlockItems({ ...rest, unlinkFromInfoBlock });

  return (
    <Spacer size="l">
      <InfoBlockAddButtons openChooseModal={setOpenChooseModal} openAddModal={setOpenAddModal} />
      {itemsProps.map(
        ({ items, type, ...rest }) =>
          !!items?.length && (
            <InfoBlockItems
              items={items}
              key={type}
              type={type}
              getItemActions={getItemActions}
              {...rest}
            />
          )
      )}
      {openAddModal && (
        <CreateInfoBlockItemModal
          type={openAddModal}
          handleClose={() => setOpenAddModal(null)}
          patchInfoBlock={patchInfoBlock}
          infoBlockApiStatus={infoBlockApiStatus}
          hasError={infoBlockHasError}
        />
      )}
      {openChooseModal && (
        <ChooseInfoBlockItemModal
          Component={getInfoBlockItemTeaser(openChooseModal)}
          type={openChooseModal}
          handleClose={() => setOpenChooseModal(null)}
          handleAddNew={() => setOpenAddModal(openChooseModal)}
          patchInfoBlock={patchInfoBlock}
          infoBlockApiStatus={infoBlockApiStatus}
          hasError={infoBlockHasError}
          disabledItems={getDisabledItems(openChooseModal)}
        />
      )}
      {openEditModal && selectedItem && (
        <EditInfoBlockItemModal
          type={openEditModal}
          item={selectedItem}
          handleClose={() => setOpenEditModal(null)}
        />
      )}
      {openDeleteModal && selectedItem && (
        <DeleteInfoBlockItemModal
          deleteItem={selectedItem}
          type={openDeleteModal}
          handleClose={() => setOpenDeleteModal(null)}
        />
      )}
    </Spacer>
  );
};
